// Project
import request from "../request";

export const getPerformYardEmployees = async (environment, search) => {
	const response = await request({
		url: `/${environment}/employees`,
		method: "GET",
		params: {
			...search,
		},
	});

	return response.data.employees;
};
